var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMan(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 219,
    height: 430,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.743 27.642l-9.062-13.704c-.519 0-7.96 23.986-4.326 40.15 2.102 9.347 8.6 2.597 13.706-4.76l.282 19.373h11.102l.465-35.663-12.165-5.394-.002-.002z",
    fill: "url(#paint0_linear_4955_89)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.746 27.643l-2.628-3.976c.162 20.59-11.569 19.67-11.747 19.655-.037 3.736.235 7.42.987 10.766 2.102 9.347 8.6 2.597 13.706-4.76l-.316-21.685h-.002z",
    fill: "#EA9169"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.364 43.321h-5.169s4.797-8.709 7.365-18.422l-2.196 18.422zm14.655-5.01s5.17 3.692 5.206-8.237l-5.484-2.432.278 10.668z",
    fill: "#FFA17B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.668 3.985s7.95-6.288 18.376-3.066c3.83 1.183 5.055 6.046 2.172 8.842-2.136 2.07-4.493 4.792-6.353 8.062 0 0-14.466 2.589-14.195-13.838",
    fill: "url(#paint1_linear_4955_89)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M204.033 381.714L148.57 217.859h-43.062c14.677 60.84 50.124 125.693 72.751 163.855h25.774z",
    fill: "url(#paint2_linear_4955_89)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.513 381.714V217.859H61.531s2.218 83.831 21.58 163.855h22.402z",
    fill: "url(#paint3_linear_4955_89)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.345 68.699L82.2 58.65l57.239-2.891-8.256 12.94 17.363 140.843c.739 6.002-.05 12.132-2.531 17.642-3.645 8.088-11.596 16.913-28.942 16.913-24.327 0-33.128-11.107-40.032-19.35-3.62-4.321-8.788-7.426-15.509-6.887V80.226c0-4.467 3.18-8.294 7.552-9.096l13.262-2.43v-.001z",
    fill: "url(#paint4_linear_4955_89)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.343 68.698L69.08 71.13c-15.194 2.91-24.711 12.64-25.372 29.68-1.08 27.819-5.32 62.242-16.4 57.588-5.007-2.104-3.186-19.636 12.47-39.132l-8.742-7.287-5.385 8.773s-12.558-4.332-21.832 19.193c-8.224 20.864-3.695 47.408 18.748 53.18 23.09 5.94 61.609-5.792 59.775-124.426z",
    fill: "url(#paint5_linear_4955_89)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.129 203.86H82.522c-9.548 0-17.288-7.775-17.288-17.366V86.064c0-9.59 7.74-17.365 17.288-17.365h62.607c9.548 0 17.287 7.775 17.287 17.365v100.43c0 9.59-7.74 17.366-17.287 17.366z",
    fill: "url(#paint6_linear_4955_89)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.803 86.064v29.22c0 4.015 3.24 7.27 7.236 7.27h47.93c3.996 0 7.237-3.255 7.237-7.27V83.389c-1.281-8.32-8.44-14.69-17.083-14.69H84.172v.08c8.77.838 15.63 8.256 15.63 17.285z",
    fill: "url(#paint7_linear_4955_89)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.972 213.182a2.641 2.641 0 01-1.861-.776 2.638 2.638 0 01-.767-1.864v-108.06a2.626 2.626 0 011.62-2.437 2.628 2.628 0 011.008-.203 2.629 2.629 0 012.428 1.632c.131.319.199.662.198 1.008v108.06a2.64 2.64 0 01-1.619 2.437 2.636 2.636 0 01-1.007.203m29.857 0a2.641 2.641 0 01-1.861-.776 2.638 2.638 0 01-.767-1.864v-108.06a2.626 2.626 0 011.62-2.437 2.628 2.628 0 011.008-.203 2.623 2.623 0 011.86.776 2.644 2.644 0 01.767 1.864v108.06a2.64 2.64 0 01-.767 1.864 2.637 2.637 0 01-1.86.776",
    fill: "#02302C"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178.786 143.938h-59.731v40.407h59.732c10.63 0 19.246-9.046 19.246-20.204 0-11.158-8.616-20.204-19.246-20.204",
    fill: "url(#paint8_linear_4955_89)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.235 143.938h-5.132c10.63 0 19.246 9.045 19.246 20.203s-8.617 20.204-19.246 20.204h5.133c10.63 0 19.246-9.046 19.246-20.204 0-11.158-8.616-20.204-19.246-20.204m-28.58.001h-5.133c10.629 0 19.246 9.045 19.246 20.203s-8.617 20.204-19.246 20.204h5.133c10.63 0 19.246-9.046 19.246-20.204 0-11.158-8.617-20.204-19.246-20.204",
    fill: "#02302C"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.298 164.141c0 11.159-8.618 20.204-19.246 20.204-10.63 0-19.247-9.045-19.247-20.204 0-11.158 8.618-20.204 19.247-20.204 10.628 0 19.246 9.046 19.246 20.204z",
    fill: "url(#paint9_linear_4955_89)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.775 119.266l3.08-3.822.75-11.966-8.582 11.828 4.752 3.96z",
    fill: "url(#paint10_linear_4955_89)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M198.56 415.353c-21.1 2.98-29.037 10.296-29.037 10.296h49.381l-8.54-25.232h-20.7c5.962 9.5 8.896 14.936 8.896 14.936",
    fill: "url(#paint11_linear_4955_89)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.513 425.648v-25.23H87.999a456.946 456.946 0 004.237 14.276s-28.957 4.532-36.103 10.955h49.38v-.001z",
    fill: "url(#paint12_linear_4955_89)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.509 381.715v18.702H95.077l-2.124-18.702h12.556z",
    fill: "url(#paint13_linear_4955_89)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M204.036 381.715l6.33 18.702h-12.223l-8.62-18.702h14.513z",
    fill: "url(#paint14_linear_4955_89)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.133 425.647v1.963c0 .834.988 1.27 1.599.705a.956.956 0 011.29 0l.478.441c.634.586 1.61.586 2.244 0a1.655 1.655 0 012.245 0c.635.586 1.61.586 2.245 0a1.659 1.659 0 012.244 0c.635.586 1.61.586 2.245 0a1.659 1.659 0 012.244 0c.635.586 1.61.586 2.245 0a1.659 1.659 0 012.244 0c.635.586 1.61.586 2.245 0a1.655 1.655 0 012.245 0c.634.586 1.61.586 2.244 0a1.66 1.66 0 012.245 0c.634.586 1.61.586 2.244 0a1.66 1.66 0 012.245 0c.635.586 1.61.586 2.245 0a1.659 1.659 0 012.244 0c.635.586 1.61.586 2.245 0a1.659 1.659 0 012.244 0c.634.586 1.61.586 2.244 0l.478-.44a.95.95 0 011.29 0c.612.564 1.599.128 1.599-.706v-1.962h-49.38v-.001z",
    fill: "url(#paint15_linear_4955_89)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.523 425.647v1.963c0 .834.988 1.27 1.6.705a.956.956 0 011.29 0l.478.441c.633.586 1.61.586 2.244 0a1.657 1.657 0 012.244 0h.001c.634.586 1.61.586 2.244 0a1.657 1.657 0 012.244 0h.001c.635.586 1.61.586 2.244 0a1.657 1.657 0 012.245 0c.634.586 1.61.586 2.245 0a1.657 1.657 0 012.244 0c.634.586 1.61.586 2.244 0h.001a1.657 1.657 0 012.244 0c.635.586 1.61.586 2.245 0a1.662 1.662 0 012.245 0c.634.586 1.61.586 2.244 0a1.662 1.662 0 012.245 0c.634.586 1.61.586 2.244 0a1.657 1.657 0 012.244 0c.636.586 1.61.586 2.245 0a1.657 1.657 0 012.245 0c.634.586 1.61.586 2.244 0l.477-.44a.952.952 0 011.29 0c.612.564 1.6.128 1.6-.706v-1.962h-49.38l-.001-.001z",
    fill: "url(#paint16_linear_4955_89)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.844 11.621c.66 4.465 4.459 20.485 25.141 23.31 1.166.16 2.226-.696 2.343-1.87.282-2.85 1.04-8.057 3-12.298a2.096 2.096 0 00-1.47-2.94c-4.304-.903-12.112-3.903-14.194-13.838-.279-1.332-1.71-2.07-2.932-1.484-2.67 1.28-7.05 3.672-11.195 7.236a2.08 2.08 0 00-.693 1.884",
    fill: "url(#paint17_linear_4955_89)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.234 186.495c0 9.591 7.74 17.365 17.287 17.365 9.547 0 17.288-7.774 17.288-17.365v-33.667H65.234v33.667z",
    fill: "#02302C"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.09 152.829H69.945V134.95c0-3.746 3.023-6.783 6.752-6.783h11.641c3.73 0 6.752 3.037 6.752 6.783v17.88-.001z",
    fill: "url(#paint18_linear_4955_89)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.788 122.361h-2.87l.82-3.816a1.21 1.21 0 00-.66-1.353 1.23 1.23 0 00-.523-.12h-4.021c-.771 0-1.345.716-1.183 1.473l.82 3.816h-2.87a2.727 2.727 0 00-2.715 2.729v3.076h15.918v-3.076a2.722 2.722 0 00-2.716-2.729",
    fill: "#02302C"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.492 395.236h11.021v5.18H95.08l-.588-5.18zm101.266 0h12.857l1.754 5.18h-12.223l-2.388-5.18z",
    fill: "#EA9169"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M120.902 164.702c-4.18-3.418-8.312 2.293-6.29 6.886 3.045 6.916 12.6 3.009 13.782-5.68.987-7.255-5.2-16.318-14.858-11.094-10.224 5.528-10.09 21.768.289 29.531",
    stroke: "#0A6849",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4955_89",
    x1: 84.487,
    y1: 55.71,
    x2: 74.412,
    y2: 48.819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9F79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBE99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4955_89",
    x1: 97.963,
    y1: 7.092,
    x2: 89.753,
    y2: 12.582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A6849"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D8B67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4955_89",
    x1: 149.235,
    y1: 245.949,
    x2: 177.742,
    y2: 377.846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02302C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A6849"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4955_89",
    x1: 82.989,
    y1: 252.849,
    x2: 92.53,
    y2: 381.056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02302C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A6849"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4955_89",
    x1: 70.369,
    y1: 182.142,
    x2: 137.973,
    y2: 182.142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8A809"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD543"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4955_89",
    x1: 20.413,
    y1: 183.473,
    x2: 53.505,
    y2: 153.745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8A809"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD543"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4955_89",
    x1: 106.407,
    y1: 157.997,
    x2: 90.971,
    y2: 85.784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A6849"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D8B67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4955_89",
    x1: 105.217,
    y1: 111.213,
    x2: 98.212,
    y2: 124.419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A6849"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D8B67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_4955_89",
    x1: 205.02,
    y1: 157.999,
    x2: 158.145,
    y2: 189.188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42CD93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#98DCB8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_4955_89",
    x1: 108.28,
    y1: 151.248,
    x2: 138.4,
    y2: 192.697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42CD93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#98DCB8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_4955_89",
    x1: 37.53,
    y1: 112.423,
    x2: 40.829,
    y2: 110.916,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9F79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBE99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_4955_89",
    x1: 218.904,
    y1: 417.486,
    x2: 194.065,
    y2: 394.713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8A809"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD543"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_4955_89",
    x1: 105.513,
    y1: 417.326,
    x2: 83.282,
    y2: 394.785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8A809"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD543"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_4955_89",
    x1: 101.964,
    y1: 381.715,
    x2: 101.964,
    y2: 396.427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9F79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBE99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_4955_89",
    x1: 204.482,
    y1: 381.715,
    x2: 204.482,
    y2: 396.427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9F79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBE99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_4955_89",
    x1: 57.533,
    y1: 427.422,
    x2: 105.513,
    y2: 427.422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02302C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A6849"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_4955_89",
    x1: 170.795,
    y1: 427.422,
    x2: 218.904,
    y2: 427.422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02302C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A6849"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_4955_89",
    x1: 100.859,
    y1: 12.702,
    x2: 81.138,
    y2: 22.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A6849"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D8B67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_4955_89",
    x1: 95.09,
    y1: 140.498,
    x2: 70.13,
    y2: 152.739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42CD93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#98DCB8"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMan);
export default __webpack_public_path__ + "static/media/man.1d93ce059149720cebf0673ba45178e9.svg";
export { ForwardRef as ReactComponent };